import {Card, Spinner} from 'react-bootstrap'
import Chart from 'react-apexcharts'
import {ApexOptions} from 'apexcharts'

interface IPeriodData {
  period: string
  periodLabel: string
  policiesCount: number
  applicantsCount: number
}

interface IPolicyDashboardChartProps {
  periodData: IPeriodData[]
  dateCriteria: 'submitted' | 'effective'
  loading: boolean
}

export const PolicyDashboardChart = ({
  periodData,
  dateCriteria,
  loading,
}: IPolicyDashboardChartProps) => {
  const title = `Policies ${dateCriteria === 'submitted' ? 'submitted' : 'effective'} each ${periodData.length > 0 && periodData[0].period.length > 7 ? 'day' : 'month'}`

  const categories = periodData.map((d) => d.periodLabel)
  const policiesData = periodData.map((d) => d.policiesCount)
  const applicantsData = periodData.map((d) => d.applicantsCount)

  const options: ApexOptions = {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        borderRadius: 4,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: categories,
      labels: {
        rotate: -45,
        rotateAlways: false,
      },
    },
    yaxis: {
      title: {
        text: 'Count',
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: (val: number) => {
          return val.toString()
        },
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
    },
    colors: ['#FFA800', '#5BC0DE'],
  }

  const series = [
    {
      name: 'Policies',
      data: policiesData,
    },
    {
      name: 'Applicants',
      data: applicantsData,
    },
  ]

  return (
    <Card className='card-flush'>
      <Card.Header className='border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>{title}</span>
          <span className='text-muted fw-semibold fs-7'>
            Number of policies vs. applicants grouped by{' '}
            {periodData.length > 0 && periodData[0].period.length > 7 ? 'day' : 'month'}
          </span>
        </h3>
      </Card.Header>
      <Card.Body>
        {loading && (
          <div className='d-flex justify-content-center align-items-center' style={{height: 350}}>
            <Spinner animation='border' />
          </div>
        )}
        {!loading && periodData.length === 0 && (
          <div className='d-flex justify-content-center align-items-center' style={{height: 350}}>
            <p className='text-muted'>No data available for the selected period</p>
          </div>
        )}
        {!loading && periodData.length > 0 && (
          <Chart options={options} series={series} type='bar' height={350} />
        )}
      </Card.Body>
    </Card>
  )
}
